<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">เพิ่มข้อมูลขนส่ง</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">เลขทะเบียน:</label>
                  <input
                    id="trcCarReg"
                    name="trcCarReg"
                    v-model="trcCarReg"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="เลขทะเบียน"
                  />
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">ประเภทบริษัท:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'trcCompanyType'"
                    :name="'trcCompanyType'"
                    :select2-options="trcCompanyTypeOptions"
                    v-model="trcCompanyType"
                    ref="trcCompanyTypeSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">บริษัท:</label>
                  <div v-show="trcCompanyType == 'agent'">
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'trcAgentId'"
                      :name="'trcAgentId'"
                      :select2-options="trcAgentOptions"
                      v-model="trcAgentId"
                      ref="trcAgentIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="trcCompanyType == 'vendor'">
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'trcVendorId'"
                      :name="'trcVendorId'"
                      :select2-options="trcVendorOptions"
                      @selectChange="VenderChange"
                      v-model="trcCompanyId"
                      ref="trcVendorIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="!trcCompanyType">
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'trcCompanyId'"
                      :name="'trcCompanyId'"
                      :select2-options="trcCompanyIdOptions"
                      v-model="trcCompanyId"
                      ref="trcCompanyIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label-required">ชื่อคนขับ:</label>
                  <input
                    id="trcDriverFirstName"
                    name="trcDriverFirstName"
                    v-model="trcDriverFirstName"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="ชื่อ"
                  />
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label-required">นามสกุล</label>
                  <input
                    id="trcDriverLastName"
                    name="trcDriverLastName"
                    v-model="trcDriverLastName"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="นามสกุล"
                  />
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">เบอร์ติดต่อ:</label>
                  <input
                    id="trcDriverTel"
                    name="trcDriverTel"
                    v-model="trcDriverTel"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    placeholder="เบอร์ติดต่อ"
                  />
                </div>
              </div>
              <div class="row col-xl-12 w3-container">
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label-required"
                      >ผู้ประสานงาน(Boonrawd):</label
                    >
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'trcEmpId'"
                      :name="'trcEmpId'"
                      :select2-options="trcEmpIdOptions"
                      @selectChange="onTrcEmpIdChange"
                      v-model="trcEmpId"
                      ref="trcEmpIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">เบอร์ติดต่อ:</label>
                    <input
                      id="trcEmpTel"
                      name="trcEmpTel"
                      v-model="trcEmpTel"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="เบอร์ติดต่อ"
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">อีเมล:</label>
                    <input
                      id="trcEmpEmail"
                      name="trcEmpEmail"
                      v-model="trcEmpEmail"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="อีเมล"
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">ตำแหน่ง:</label>
                    <input
                      id="trcEmpPosition"
                      name="trcEmpPosition"
                      v-model="trcEmpPosition"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="ตำแหน่ง"
                    />
                  </div>
                </div>
              </div>
              <div class="row col-xl-12 w3-container">
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label-required">ผู้ประสานงาน(ภายนอก):</label>
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'trcTransitContactorId'"
                      :name="'trcTransitContactorId'"
                      :select2-options="trcTransitContactorIdOptions"
                      @selectChange="onTrcTransitContactorIdChange"
                      v-model="trcTransitContactorId"
                      ref="trcTransitContactorIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">เบอร์ติดต่อ:</label>
                    <input
                      id="trcTransitContactorTel"
                      name="trcTransitContactorTel"
                      v-model="trcTransitContactorTel"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="เบอร์ติดต่อ"
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">อีเมล:</label>
                    <input
                      id="trcTransitContactorEmail"
                      name="trcTransitContactorEmail"
                      v-model="trcTransitContactorEmail"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="อีเมล"
                    />
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="form-group">
                    <label class="label">ตำแหน่ง:</label>
                    <input
                      id="trcTransitContactorPosition"
                      name="trcTransitContactorPosition"
                      v-model="trcTransitContactorPosition"
                      type="text"
                      maxlength="256"
                      class="form-control"
                      placeholder="ตำแหน่ง"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="trcInActiveStatus"
                        id="trcInActiveStatus"
                        v-model="trcInActiveStatus"
                      />
                      <span></span>
                      เปิดใช้งาน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data() {
    var self = this;

    return {
      trcCarReg: null,
      trcCompanyType: null,
      trcCompanyId: null,
      trcAgentId: null,
      trcVendorId: null,
      trcDriverFirstName: null,
      trcDriverLastName: null,
      trcDriverTel: null,
      trcTransitContactorId: null,
      trcEmpId: null,
      trcInActiveStatus: true,
      trcEmpTel: null,
      trcEmpEmail: null,
      trcEmpPosition: null,
      trcTransitContactorTel: null,
      trcTransitContactorEmail: null,
      trcTransitContactorPosition: null,
      // Configurations
      trcCompanyTypeOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          { id: "agent", text: "Agent", data: null },
          { id: "vendor", text: "Supplier", data: null },
        ],
      },
      trcCompanyIdOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "", text: "", data: null }],
      },
      trcAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      trcVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      trcEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      trcTransitContactorIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/TransitContactor/Select2TransitContactor",
          data: function(params) {
            var tmp = "";
            console.log(self.trcCompanyType);
            if (self.trcCompanyType == "agent") {
              tmp = self.trcAgentId;
            } else if (self.trcCompanyType == "vendor") {
              tmp = self.trcVendorId;
            }

            var query = {
              search: params.term,
              page: params.page || 1,
              companyType: self.trcCompanyType,
              companyId: tmp,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      var tmp = "";
      if (this.trcCompanyType == "agent") {
        tmp = this.trcAgentId;
      } else if (this.trcCompanyType == "vendor") {
        tmp = this.trcVendorId;
      }
      axios
        .post("/Api/Transport", {
          CarReg: this.trcCarReg,
          CompanyType: this.trcCompanyType,
          CompanyId: tmp,
          DriverFirstName: this.trcDriverFirstName,
          DriverLastName: this.trcDriverLastName,
          DriverTel: this.trcDriverTel,
          TransitContactorId: this.trcTransitContactorId,
          EmpId: this.trcEmpId,
          InActiveStatus: !this.trcInActiveStatus,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onTrcEmpIdChange: function(id, text, data, ref) {
      this.trcEmpEmail = data[0].data.email;
      this.trcEmpTel = data[0].data.tel;
      this.trcEmpPosition = data[0].data.positionName;
    },
    onTrcTransitContactorIdChange: function(id, text, data, ref) {
      this.trcTransitContactorEmail = data[0].data.email;
      this.trcTransitContactorTel = data[0].data.tel;
      this.trcTransitContactorPosition = data[0].data.position;
    },
    VenderChange: function(id, text, data, ref) {
      this.trcVendorId = text;
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        trcCarReg: "required",
        trcCompanyType: "required",
        trcAgentId: "required",
        trcVendorId: "required",
        trcCompanyId: "required",
        trcDriverFirstName: "required",
        trcDriverLastName: "required",
        trcDriverTel: "required",
        trcTransitContactorId: "required",
        trcEmpId: "required",
      },
      messages: {
        trcCarReg: "กรุณากรอกเลขทะเบียน",
        trcCompanyType: "กรุณาเลือกประเภทบริษัท",
        trcAgentId: "กรุณาเลือกบริษัท",
        trcVendorId: "กรุณาเลือกบริษัท",
        trcCompanyId: "กรุณาเลือกบริษัท",
        trcDriverFirstName: "กรุณากรอกชื่อคนขับ",
        trcDriverLastName: "กรุณากรอกนามสกุล",
        trcDriverTel: "กรุณากรอกเบอร์ติดต่อ",
        trcTransitContactorId: "กรุณาเลือกผู้ประสานงาน(ภายนอก)",
        trcEmpId: "กรุณาเลือกผู้ประสานงาน(Boonrawd)",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Transport/CreateTransport.vue